import { Injectable } from '@angular/core';
import {
  CanActivate,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GuardService } from './service/guard.service';

@Injectable({
  providedIn: 'root'
})
export class SealInnerSignGuard implements CanActivate {
  constructor(
    private guardService: GuardService
  ) { }

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.isEnableSealInnerSign();
  }

  isEnableSealInnerSign(): Observable<boolean | UrlTree> {
    return this.guardService.activeSealInnerSign()
      .pipe(
        map((status) => {
          if (status === true) {
            return true;
          } else {
            return false;
          }
        })
      );
  }
}
